export const bottomInfoMessages = [
  '• 생산실적조회 화면에서는 완료된 작업지시에 대한 생산실적을 조회할 수 있습니다.',
  '• 생산수량, 양품/불량 수량, 작업시간 등의 정보를 확인하여 생산이력을 분석할 수 있습니다.',
  '• 출력 및 엑셀 내보내기 기능을 통해 생산실적 데이터를 활용할 수 있습니다.',
];

export const helpModalMessages = {
  title: '생산실적조회 도움말',
  paragraphs: [
    '• 생산실적조회에서는 완료된 생산 작업의 실적 정보를 조회할 수 있습니다.',
    '• 상단의 검색조건을 사용하여 특정 기간, 제품, 작업지시 등의 생산실적을 조회할 수 있습니다.',
    '• 그리드의 컬럼을 클릭하여 정렬하거나, 필터 기능을 사용하여 데이터를 필터링할 수 있습니다.',
    '• 출력 및 엑셀 내보내기 기능을 통해 생산실적 데이터를 활용할 수 있습니다.',
  ],
}; 